<template>
	<div v-loading="loading" element-loading-text="拼命加载中..." element-loading-spinner="el-icon-loading" class="base_scroll_page">
		<div class="b_scroller">
			<el-collapse :value="activeNames">
				<el-collapse-item title="基本信息" name="basic">
					<p style="text-indent: 2em">创建机构： {{ formName }}</p>
					<p style="text-indent: 2em">我的机构名称： {{ authForm }}</p>
				</el-collapse-item>
				<el-collapse-item title="消费信息" name="consume">
					<div class="base_showTable">
						<table>
							<tr>
								<th>项目</th>
								<th>已充值次数</th>
								<th>已消费次数</th>
								<th>剩余次数</th>
							</tr>
							<template v-for="(v, i) in list">
								<tr :key="i" v-if="v.uversionFlag != 2 && v.uversionFlag != 3">
									<td>{{ v.name || '' }}</td>
									<td>{{ v.urTotalTime || 0 }}</td>
									<td>{{ v.ucTotalTime || 0 }}</td>
									<td>{{ v.urcTime || 0 }}</td>
								</tr>
							</template>
						</table>
					</div>
				</el-collapse-item>
				<el-collapse-item title="生产记录" name="consume" v-if="authInfo.uid == '702640136810405888'">
					<div class="base_showTable">
						<table>
							<tr>
								<th>生产批号</th>
								<th>型号规格</th>
								<th>生产日期</th>
								<th>次数</th>
							</tr>
							<tr>
								<th>P201605001</th>
								<th>KFSJ-RS-YY2014</th>
								<th>2016/5/21</th>
								<th>10000000</th>
							</tr>
							<tr>
								<th>P202302001</th>
								<th>KFSJ-RS-YY2014</th>
								<th>2023/2/28</th>
								<th>1000000000</th>
							</tr>
							<!-- <template v-for="(v, i) in list">
								<tr>
									P201605001
								</tr>
							</template> -->
						</table>
					</div>
				</el-collapse-item>
			</el-collapse>
		</div>
	</div>
</template>

<script>
import Api from '../../../../api/index.js';
import { mapState } from 'vuex';

export default {
	data() {
		return {
			loading: false,
			activeNames: ['basic', 'consume'],
			transitionList: [],
			list: [],
			formName: '',
			authForm: ''
		};
	},
	computed: {
		...mapState(['authInfo', 'authProduct'])
	},
	mounted() {
		this.getData();
	},
	methods: {
		/************************ @Ajax *******************************/
		// 请求数据
		getData() {
			const that = this;
			that.loading = true;
			var _requestData = {
				bUserId: that.authInfo.uid
			};
			Api.findAuthDetail(_requestData).then(
				(res) => {
					console.log(res);
					that.loading = false;
					if (res.data.success) {
						// 702640136810405888 胡
						// 269227852090843136 王
						if (that.authInfo.uid == '702640136810405888') {
							that.formName = res.data.data.enterpriseName;
							that.authForm = res.data.data.uName;
							res.data.data.underlineInfoList.forEach((item) => {
								if (item.uversionFlag == 10) {
									// console.log(item);
									let items = {
										...item,
										ucTotalTime: item.ucTotalTime + 333721 + 130926,
										urcTime: item.urcTime - 333721 - 130926
									};
									that.transitionList.push(items);
								}
							});
							that.formatData();
							// uversionFlag
						} else {
							that.formName = res.data.data.enterpriseName;
							that.authForm = res.data.data.uName;
							that.transitionList = res.data.data.underlineInfoList || [];
							that.formatData();
						}
					} else {
						that.$message.error(res.data.message);
					}
				},
				(e) => {
					that.loading = false;
					that.$message.error(e.message);
				}
			);
		},
		formatData() {
			var _l = [];
			for (var i = 0; i < this.transitionList.length; i++) {
				var _o = this.transitionList[i];
				for (var ii = 0; ii < this.authProduct.length; ii++) {
					_o.uversionFlag == this.authProduct[ii].id && (_o.name = this.authProduct[ii].name);
				}
				_l.push(_o);
			}
			this.list = _l;
		}
	},
	watch: {
		authProduct() {
			this.formatData();
		}
	}
};
</script>

<style scoped></style>
